<template>
  <div>
    <SetHeader />
    <a-radio-group
      style="margin: 0 15px;"
      v-model:value="langCode"
      v-if="langDic && langDic.length"
    >
      <a-radio-button
        v-for="item in langDic"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </a-radio-button>
    </a-radio-group>
    <Container />
    <div class="h100"></div>
    <div class="bottomBar">
      <div class="fr">
        <a-button type="default" class="mr10" @click="() => jumpPage()"
          >取消</a-button
        >
        <a-button type="primary" @click="() => save()">保存</a-button>
      </div>
    </div>
  </div>
  <BigPic />
</template>
<script>
import { toRefs, reactive, onMounted, provide } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SetHeader from './components/SetHeader.vue'
import Container from './components/Container.vue'
import BigPic from './components/BigPic.vue'
import useAPI from 'UseApi'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
const {
  commonConfig_footerPolicy_detail_post_,
  commonConfig_footerPolicy_save_post_,
  common_lang_get_
} = useAPI(null, [7056, 3426])
export default {
  components: {
    SetHeader,
    Container,
    BigPic
  },
  setup() {
    const state = reactive({
      langCode: '',
      langDic: [],
      defaultLanguageCode: '',
      defaultLanguageIndex: 0,
      common_lang_get: async () => {
        await common_lang_get_({ ...state.route.query }, state)
      },
      dragIcon:
        'https://cdn-image.kapeixi.cn/web/42debfc3-7cc4-4563-97cf-463a8c07d271/drag.png',
      inputLengthCut: (val, key, type = 'footerPolicyParams') => {
        let value = val
          .split('')
          .splice(0, 50)
          .join('')
        state[`${type}`][key] = value
      },
      bigPic: null,
      visiblePic: false,
      changeVisiblePic: (visiblePic = false, bigPic = null) => {
        state.visiblePic = visiblePic
        state.bigPic = bigPic
      },
      upload: (info = null, index) => {
        state.fileList = []
        state.info = info
        const { file } = info
        const isLtMaxM = file.size / 1024 <= 20
        if (isLtMaxM) {
          state.uploadHandleChange(index)
        } else {
          message.warning('上传大小不能超过20k!')
          return
        }
      },
      uploadHeaders: {
        Authorization:
          localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
      },
      uploadHandleChange: async (index = null) => {
        const { info } = state
        if (info && info.file) {
          const api = `${process.env.VUE_APP_CMS}/cms/material/upload`
          const { success, retInfo, data } = await formRequest(api, {
            file: info.file
          })
          if (success) {
            const { url } = data
            const langIndex = state.footerPolicyItemDTOList[
              index
            ].langs?.findIndex(v => v.langCode === state.langCode)
            if (langIndex > -1)
              state.footerPolicyItemDTOList[index].langs[langIndex].imgUrl = url
          } else {
            message.error(retInfo)
          }
        } else {
          message.info('文件未上传！')
        }
      },
      tabType: 1,
      tabTypeChange: (tabType = 1) => {
        state.tabType = tabType
        // state.popupParams.popType = tabType - 0 === 1 ? 1 : 2
      },
      jumpPage: () => {
        state.router.push({
          path: 'PublicSet',
          query: {
            ...state.route.query
          }
        })
      },
      initList: async () => {
        let params = {
          ...state.footerPolicyParams,
          ...state.queryParams
        }
        delete params?.langcode
        delete params?.lang
        let api = commonConfig_footerPolicy_detail_post_
        await api(params, state)
        console.log(state.footerPolicyParams)
      },
      footerPolicyParams: {
        status: 0, // 0 禁用 1启用
        filterUrl: null
      },
      footerPolicyItemDTOList: [],
      footerPolicy: {},
      footerPolicySet: {
        footerPolicyId: null,
        imgUrl: null,
        link: null,
        orderNum: null,
        title: null
      },
      popupParams: {},
      restPopupParams: {
        creator: null, // 创建人
        delayTime: 5, //弹窗延迟出现时间,单位秒
        filterUrl: null, // 不展示的路由：此为C端哪个页面不展示topbar，以分号分割；
        id: null, //主键id
        modifier: null, // 修改人
        oncePopPerUser: true, // 每个用户仅弹出一次- 0.否 、1. 是
        popType: 1, //弹窗类型-1.订阅弹窗、2.注册弹窗
        popupTextDTOS: [], //弹窗文案集合
        sidebarContent: null, //侧边栏内容
        sidebarType: 1, // 侧边栏类型 1.文本、2.图片
        status: 1, // 状态 -0.禁用、1.启用
        userType: 1 //触发用户类型-1.所有用户（新访+老访）、2.新用户（新访）、3.未注册用户（新访+老访的未注册用户)
      },
      topBarItem: {
        color: '#000000', // 颜色
        countdown: 0, // 0 不开启 1 开启
        endTime: null, // 倒计时活动结束时间
        link: null, // 链接
        imgUrl: null,
        orderNum: 0, // 顺序
        startTime: null, // 活动开始时间
        text: null, // 文案
        topbarConfigId: null,
        times: [], // topbar 配置id
        itemType: 1
      },
      removeTopbar: (index = 1) => {
        state.footerPolicyItemDTOList.splice(index, 1)
      },
      addTopBarItem: () => {
        let footerPolicyItemDTOList = [...state.footerPolicyItemDTOList]
        footerPolicyItemDTOList.splice(
          footerPolicyItemDTOList.length - 1,
          0,
          JSON.parse(JSON.stringify(state.topBarItem))
        )
        state.footerPolicyItemDTOList = [...footerPolicyItemDTOList]
      },
      topbarParams: {},
      resetTopbarParams: {
        backCol: '#000000', //背景颜色
        ceiling: true, // 是否吸顶-0.否、1.是
        creator: null, // 创建人
        filterUrl: '', // 不展示的路由：此为C端哪个页面不展示topbar，以分号分割
        id: null, // 主键id
        leftRightTime: 5, // 左右轮播时间，单位秒
        modifier: null, //修改人
        status: 0, //状态 -0.禁用、1.启用
        topbarItemDTOList: [
          {
            addButton: false,
            color: '#000000', // 颜色
            countdown: 0, // 0 不开启 1 开启
            endTime: null, // 倒计时活动结束时间
            link: null, // 链接
            orderNum: 0, // 顺序
            startTime: null, // 活动开始时间
            text: null, // 文案
            topbarConfigId: null // topbar 配置id
          },
          {
            addButton: true,
            color: '#000000', // 颜色
            countdown: 0, // 0 不开启 1 开启
            endTime: null, // 倒计时活动结束时间
            link: null, // 链接
            orderNum: 0, // 顺序
            startTime: null, // 活动开始时间
            text: null, // 文案
            topbarConfigId: null // topbar 配置id
          }
        ], // topbar子项
        upDownTime: 5 // 上下轮播时间，单位秒
      },
      queryParams: {},
      route: useRoute(),
      router: useRouter(),
      activeKey: 1,
      check: 1,
      checkPic: 1,
      checkChange: (check = 1) => {
        state.check = check
      },
      checkPicChange: (checkPic = 1) => {
        state.checkPic = checkPic
      },
      getImgUrl: (element, setNull) => {
        const index = element?.langs?.findIndex(
          v => v.langCode === state.langCode
        )
        if (index > -1) {
          let imgUrl = element?.langs[index]?.imgUrl
          if (setNull && element?.langs && element?.langs?.length)
            element.langs[index].imgUrl = null
          return imgUrl
        }
        return null
      },
      save: () => {
        if (
          [null, '', undefined].includes(state.footerPolicyParams.filterUrl)
        ) {
          message.warning('不展示的路由不能为空！')
          return
        }
        let footerPolicyItemDTOList = state.footerPolicyItemDTOList.filter(
          v => !v.addButton
        )
        // : { ...state.topbarParams, topbarItemDTOList: state.topbarParams?.topbarItemDTOList?.map(v => ({ ...v, text: v.langs[0].text })) }),
        footerPolicyItemDTOList = footerPolicyItemDTOList.map((v, index) => {
          if ([null, '', undefined].includes(v.footerPolicyId)) {
            delete v.footerPolicyId
          }
          v = {
            ...v,
            ...v?.langs[state.defaultLanguageIndex]
          }
          v.orderNum = index + 1
          return v
        })

        console.log('@', footerPolicyItemDTOList)
        for (let index in footerPolicyItemDTOList) {
          let v = footerPolicyItemDTOList[index]
          for (let sub of v.langs) {
            if (!sub.title) return state.submitError('文案', sub, index)
            if (!sub.imgUrl) return state.submitError('图片Icon', sub, index)
          }
        }
        let params = {
          ...state.queryParams,
          ...state.footerPolicyParams,
          footerPolicyItemDTOList
        }
        let api = commonConfig_footerPolicy_save_post_
        api(params, state)
      },
      // 只是为了整理下错误信息
      submitError: (prop, sub, index) => {
        const label = state.langDic.find(v => v.value === sub.langCode)?.label
        return message.error(
          `多语言 "${label}" 下的 "政策条款${parseInt(index) +
            1}" 当中的 "${prop}" 不能为空`
        )
      }
    })

    provide('initState', state)
    onMounted(async () => {
      state.queryParams = state.route.query
      await state.common_lang_get()
      state.topBarItem = {
        ...state.topBarItem,
        langs: state?.langDic?.map(v => ({
          langCode: v.value,
          title: null,
          imgUrl: null
        }))
      }
      state.initList()
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style>
@font-face {
  font-family: 'Muli-ExtraBold';
  src: url('https://cdn-image.kapeixi.cn/web/46e5a7eb-2b54-4ab9-805c-157cbba63070/Satoshi-Black.woff2');
}

.Muli-ExtraBold,
.ql-font-Muli-ExtraBold {
  font-family: Muli-ExtraBold;
}

@font-face {
  font-family: 'Muli-Bold';
  src: url('https://cdn-image.kapeixi.cn/web/c8fca30d-913f-49af-931c-c8142f02d1ef/Satoshi-Bold.woff2');
}

.Muli-Bold,
.ql-font-Muli-Bold {
  font-family: Muli-Bold;
}

@font-face {
  font-family: 'Muli-SemiBold';
  src: url('https://cdn-image.kapeixi.cn/web/316fb9cc-e896-49bb-a52c-f14e9eab02e8/Satoshi-Medium.woff2');
}

.Muli-SemiBold,
.ql-font-Muli-SemiBold {
  font-family: Muli-SemiBold;
}

@font-face {
  font-family: 'Muli-Light';
  src: url('https://cdn-image.kapeixi.cn/web/ca5162f5-22ec-4bca-9686-2efac5d29604/Satoshi-Regular.woff2');
}

.AvenirNext-Regular,
.ql-font-AvenirNext-Regular {
  font-family: Muli-Light;
}
</style>
<style scoped>
.bottomBar {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #ffffff;
  z-index: 999;
  padding: 10px;
  width: calc(100%);
  border-top: 1px solid #f8f8f8;
}
</style>
<style>
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='10px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='10px']::before {
  content: '10px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='12px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='12px']::before {
  content: '12px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='14px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='14px']::before {
  content: '14px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='16px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='16px']::before {
  content: '16px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='18px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='18px']::before {
  content: '18px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='20px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='20px']::before {
  content: '20px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='22px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='22px']::before {
  content: '22px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='24px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='24px']::before {
  content: '24px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='26px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='26px']::before {
  content: '26px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='28px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='28px']::before {
  content: '28px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='30px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='30px']::before {
  content: '30px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='32px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='32px']::before {
  content: '32px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='34px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='34px']::before {
  content: '34px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='36px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='36px']::before {
  content: '36px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='38px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='38px']::before {
  content: '38px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='40px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='40px']::before {
  content: '40px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='45px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='45px']::before {
  content: '45px';
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='50px']::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='50px']::before {
  content: '50px';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-ExtraBold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-ExtraBold']::before {
  content: 'AvenirNext-Bold';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-Bold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-Bold']::before {
  content: 'AvenirNext-Demi';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-SemiBold']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-SemiBold']::before {
  content: 'AvenirNext-Medium';
}

.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-label[data-value='Muli-Light']::before,
.ql-snow
  .ql-font.ql-picker.ql-expanded
  .ql-picker-item[data-value='Muli-Light']::before {
  content: 'AvenirNext-Regular';
}

/**设置默认字体显示
**/
.ql-container {
  font-size: 16px;
}
</style>
